// src/components/CotationOverlay.jsx
import React, { useEffect, useCallback } from 'react';
import CotationWizard from './CotationWizard';
import { createPortal } from 'react-dom';

export default function CotationOverlay({
  open,
  onClose,
  patient,
  passageId,
  token,
  patients,
  setPatients,
  currentPage,
}) {
  const onEsc = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose?.();
    },
    [onClose],
  );

  useEffect(() => {
    if (!open) return;
    window.addEventListener('keydown', onEsc);

    return () => {
      window.removeEventListener('keydown', onEsc);
    };
  }, [open, onEsc]);

  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  const pid = patient?.id ?? passageId;

  return createPortal(
    <div className="fixed inset-0 z-[1002] flex items-start justify-center bg-black/60 p-3">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />

      <section className="relative z-10 w-full max-w-3xl max-h-full overflow-y-auto scrollbar-hidden rounded-2xl bg-white shadow-xl p-4">
        <div className="min-h-0">
          <div className="max-w-[980px] mx-auto px-4 py-4">
            <CotationWizard
              embedded
              passageId={pid}
              token={token}
              patients={patients}
              setPatients={setPatients}
              onDone={onClose}
              currentPage={currentPage}
            />
          </div>
        </div>
      </section>
    </div>,
    document.body,
  );
}
